export default __webpack_public_path__ + "static/media/Icon2.b9efde9d.png";